import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isDownloadFolderContentRequestFailure({ uuid }) {
      const req = getState().find(({ folder }) => folder.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isDownloadFolderContentRequestPending({ uuid }) {
      const req = getState().find(({ folder }) => folder.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isDownloadFolderContentRequestSuccess({ uuid }) {
      const req = getState().find(({ folder }) => folder.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    getDownloadedFolderContent(folder) {
      const req = getState().find((req) => folder.uuid === req.folder.uuid);

      return req ? req.downloadedFolder : folder;
    },
  };
}

export { createSelector };
